function initFilterClose() {
  const closeButtons = document.querySelectorAll('.close-filters-mobile');
  const filtersWrappers = document.querySelectorAll('.facets-wrapper');
  
  if (closeButtons.length && filtersWrappers.length) {
    closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        filtersWrappers.forEach(wrapper => {
          wrapper.classList.remove('is-open');
        });
      });
    });
  }
}

function openFilters() {
  const filterButtons = document.querySelectorAll('.filter-button');
  const closeButtons = document.querySelectorAll('.close-filters');
  const facetsWrappers = document.querySelectorAll('.facets-wrapper');

  if (filterButtons.length) {
    filterButtons.forEach(button => {
      button.addEventListener('click', () => {
        facetsWrappers.forEach(wrapper => {
          wrapper.classList.toggle('is-open');
        });
      });
    });
  }

  if (closeButtons.length) {
    closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        facetsWrappers.forEach(wrapper => {
          wrapper.classList.remove('is-open');
        });
      });
    });
  }
}

function initOverlayClose() {
  const filtersWrappers = document.querySelectorAll('.facets-wrapper');
  const facetsVerticalSorts = document.querySelectorAll('.facets-vertical');
  
  if (facetsVerticalSorts.length && filtersWrappers.length) {
    facetsVerticalSorts.forEach(sort => {
      sort.addEventListener('click', (event) => {
        if (event.target === sort) {
          filtersWrappers.forEach(wrapper => {
            if (wrapper.classList.contains('is-open')) {
              wrapper.classList.remove('is-open');
            }
          });
        }
      });
    });
  }
}



document.addEventListener('DOMContentLoaded', () => {
  initFilterClose();
  openFilters();
  initOverlayClose();
});